<template>
  <div class="schedule-form-modal">
    <form @submit.prevent="handleSubmit">
      <WorkOrderScheduleFields
        ref="fieldsRef"
        :work-order="workOrder"
        :installer-options="installerOptions"
        :existing-work-orders="existingWorkOrders"
        :default-planning-type="defaultPlanningType"
      />

      <div class="schedule-form-modal__actions">
        <Btn type="submit" variant="secondary" :loading="loading">
          {{
            fieldsRef?.form?.planningType === 'confirmed'
              ? 'Bevestigen'
              : 'Voorlopig inplannen'
          }}
        </Btn>
      </div>
    </form>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue';

  import Btn from '@/components/partials/Btn.vue';
  import WorkOrderScheduleFields from '@/components/work-orders/WorkOrderScheduleFields.vue';

  export default defineComponent({
    name: 'ScheduleWorkOrderModal',

    components: {
      Btn,
      WorkOrderScheduleFields,
    },

    props: {
      workOrder: {
        type: Object,
        required: true,
      },
      installerOptions: {
        type: Array,
        default: () => [],
      },
      onSubmit: {
        type: Function,
        required: true,
      },
      onError: {
        type: Function,
        default: () => {},
      },
      existingWorkOrders: {
        type: Array,
        default: () => [],
      },
      defaultPlanningType: {
        type: String,
        default: null,
        validator: (v) => v === null || v === 'tentative' || v === 'confirmed',
      },
    },

    setup(props) {
      const loading = ref(false);
      const fieldsRef = ref(null);

      const handleSubmit = async () => {
        if (!fieldsRef.value?.validate()) {
          props.onError(fieldsRef.value?.errors || {});
          return;
        }

        loading.value = true;
        try {
          await props.onSubmit(fieldsRef.value.getPayload());
        } finally {
          loading.value = false;
        }
      };

      return {
        loading,
        fieldsRef,
        handleSubmit,
      };
    },
  });
</script>

<style scoped lang="scss">
  .schedule-form-modal {
    &__actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 1rem;
      padding-top: 1rem;
      border-top: 1px solid var(--slate-200);
    }
  }
</style>
